var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _rect6, _path8, _rect7, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasoline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 968,
    height: 304,
    viewBox: "0 0 968 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 872,
    cy: 248,
    r: 48,
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 856,
    cy: 248,
    r: 48,
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 248,
    r: 48,
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 248,
    r: 48,
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44V164H960L936 128H824L772 8H64.0002C24.0002 8 24 44 24 44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280 8C320 8 640 8 704 8C768 8 776 16 780 24C784 32 816 124 828 124C840 124 856 124 908 124C960 124 960 160 960 160V164",
    stroke: "black",
    strokeWidth: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240 128V243.504H960V162.582",
    stroke: "black",
    strokeWidth: 16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 260V108H504.607C521.822 108 572 153.509 608 153.509H736V260H8Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 140,
    width: 224,
    height: 112,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M759.193 41.6051L762.857 40C759.193 41.6051 759.193 41.6052 759.193 41.6054L759.193 41.6066L759.196 41.6113L759.204 41.6305L759.238 41.7073L759.37 42.0095C759.486 42.2751 759.657 42.6666 759.876 43.1694C760.315 44.1749 760.946 45.6255 761.717 47.4039C763.26 50.9611 765.36 55.8279 767.593 61.0677C772.081 71.6022 777.029 83.4766 779.1 89.3336C780.813 94.1762 779.863 97.747 778.092 100.084C776.223 102.551 773.177 104 770.141 104L635.631 104C627.598 104 623.185 101.367 620.8 99.1006C619.568 97.9288 618.792 96.7728 618.335 95.9443C618.107 95.5308 617.962 95.2036 617.88 95.0046C617.84 94.9054 617.816 94.839 617.806 94.8109C617.806 94.8101 617.805 94.8093 617.805 94.8085L617.74 94.5907L617.628 94.3457L613.986 96C617.628 94.3457 617.628 94.3456 617.628 94.3453L617.628 94.344L617.625 94.3386L617.615 94.317L617.576 94.2314L617.424 93.896C617.291 93.6016 617.094 93.1686 616.843 92.6144C616.341 91.5062 615.62 89.9138 614.745 87.9778C612.995 84.1056 610.631 78.8602 608.172 73.3659C603.221 62.3047 597.979 50.4406 596.506 46.5756C594.526 41.3799 598.418 32 609.743 32H741.639C749.072 32 753.404 34.5866 755.869 36.9107C757.139 38.1076 757.975 39.2949 758.482 40.156C758.735 40.5851 758.903 40.9273 759 41.1399C759.048 41.246 759.078 41.3189 759.092 41.3533C759.094 41.3581 759.095 41.3621 759.097 41.3653L759.134 41.4713L759.193 41.6051Z",
    stroke: "black",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 164V44C24 44 24.0002 8 64.0002 8C104 8 420 8 484 8C548 8 556 16 560 24C564 32 596 124 608 124C620 124 636 124 688 124C740 124 740 160 740 160",
    stroke: "black",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 164V44C24 44 24.0002 8 64.0002 8C86.8268 8 199.535 8 304 8",
    stroke: "black",
    strokeWidth: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 32,
    width: 72,
    height: 72,
    rx: 12,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 32,
    width: 72,
    height: 72,
    rx: 12,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 32,
    width: 72,
    height: 72,
    rx: 12,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 32,
    width: 72,
    height: 72,
    rx: 12,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 32,
    width: 72,
    height: 72,
    rx: 12,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M540.422 45.7889C544.435 53.8136 552.285 69.5321 557.055 85.1671C559.164 92.0821 557.694 96.5878 555.27 99.3758C552.696 102.338 548.492 104 544.164 104H526.729C518.767 104 515.408 100.738 513.793 97.9795C512.91 96.4697 512.451 94.9249 512.219 93.734C512.104 93.1463 512.049 92.6674 512.023 92.3542C512.01 92.1983 512.004 92.0857 512.002 92.0237C512.001 92.0011 512 91.9853 512 91.9768V91.9767V91.9705V91.9636V91.9561V91.9478V91.9388V91.9291V91.9187V91.9076V91.8958V91.8833V91.8701V91.8562V91.8264V91.7939V91.7586V91.7207V91.6801V91.6588V91.6368V91.6142V91.591V91.5425V91.4914V91.4377V91.3815V91.3228V91.2616V91.1978V91.1316V91.0629V91.0277V90.9918V90.9183V90.8424V90.7641V90.6834V90.6004V90.5151V90.4275V90.3376V90.2918V90.2454V90.151V90.103V90.0544V89.9556V89.8546V89.6461V89.5926V89.5386V89.4841V89.4291V89.2038V88.9702V88.9106V88.8504V88.7287V88.4792V88.2221V88.1566V88.0906V87.9573V87.6852V87.4058V87.3348V87.2634V87.1193V86.8259V86.6766V86.6013V86.5256V86.2187V85.9054V85.826V85.7463V85.5857V85.2598V85.0947V85.0115V84.928V84.2468V82.8192V81.3127V80.533V80.3355V80.2364V80.1371V79.7373V79.3339V79.2325V79.1308V79.029V78.9269V78.5166V78.3102V78.2067V78.103V77.2668V77.056V76.9504V76.8445V76.6324V76.5261V76.4197V75.9923V75.7778V75.6703V75.5627V75.131V74.6973V49.9397C512 44.6963 512.095 40.3433 513.843 37.175C515.139 34.8264 517.799 32.4303 524.751 32.0517C529.912 32.3529 532.659 33.9326 534.521 35.814C536.522 37.8349 537.769 40.3838 539.408 43.7311C539.728 44.3858 540.063 45.071 540.422 45.7889Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 140,
    width: 712,
    height: 40,
    rx: 20,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 244,
    r: 48,
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 656,
    cy: 244,
    r: 48,
    fill: "white",
    stroke: "black",
    strokeWidth: 16
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 244,
    r: 48,
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 244,
    r: 48,
    fill: "black",
    stroke: "white",
    strokeWidth: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasoline);
export default __webpack_public_path__ + "static/media/gasoline.319bd55d699aa77eff0ebe0e99c455a2.svg";
export { ForwardRef as ReactComponent };